<template>
  <div>
    <b-form-group id="input-group-4" label="Técnico" label-for="input-4">
      <b-form-select
        id="input-4"
        v-model="technicianSelected"
        :options="optionTechnicians"
        required
      >
        <b-form-select-option :value="null" :disabled="true"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-row>
      <b-col cols="12" class="text-center">
        <b-button @click="programarOS" class="btn-orange">
          <font-awesome-icon icon="calendar-day" /> Programar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "ProgramarOs",
  props: ["valuesProg"],
  data() {
    return {
      technicianSelected: null,
      optionTechnicians: [],
      valuesResponseProg: { show: true, message: "", hasError: false },
    };
  },
  created() {
    this.listTechnician();
  },
  computed: {
    ...mapState("module", ["username","token"]),
  },
  methods: {
    async programarOS() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/schedulings",
          {
            technicianId: this.technicianSelected,
            childId: this.valuesProg.detailId,
            user: this.username,
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        this.valuesResponseProg.message = "Programación exitosa";
      } catch (error) {
        console.log(error);
        this.valuesResponseProg.hasError = true;
        this.valuesResponseProg.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-programar");
        this.$emit("setResponse", this.valuesResponseProg);
        this.$store.commit("SET_LOADING", false);
      }
    },
    async listTechnician() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers/" +
            this.valuesProg.providerId,
            {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              },
            }
        );
        const data = response.data.technicians.map((row) => {
          return {
            value: row.id,
            text: row.name,
            state:row.state
          };
        });
        const activeTechnicians = data.filter((tec) => tec.state === "ACTIVE");
        console.log(activeTechnicians)
        this.optionTechnicians = activeTechnicians;
      } catch (error) {
        console.log(error)
      }
    },
   
  },
};
</script>
<style scoped>
</style>
